import React, { useEffect, useMemo, useRef, useState } from 'react';
import { BarChart3, ChevronDown } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip, BarChart, Bar } from 'recharts';
import { apiConnecter } from '../../../services/apiConnector';
import { useSelector } from 'react-redux';
import API_ENDPOINTS from '../../../constant/EndPoints';
import { useClickOutside } from '../../../hooks/ClickoutsideHook';
import { Clock } from 'lucide-react'
import NoDataFound from '../dataDisplay/NoDataFound';
import GeographicChart from './GeographicChart';
// import EngagementChart from './EngagementChart';
import EngagementChart from './EngagementChart'
import EngagementChartForFeedBack from './EngagementChartForFeedBack';
/**
 * Main component to display event analytics, including engagement timeline and geographic distribution.
 *
 * @param {object} props - The component props.
 * @param {string} props.eventId - The unique ID of the event to display analytics for.
 * @param {string} props.token - The user authentication token (for API calls).
 * @returns {React.ReactElement} The main Analytics dashboard layout.
 */
const ChartWrapper = ({ eventId, token }) => {
    return (
        <div className="min-h-screen text-[var(--primary-text-color)] mt-6">
            <EngagementChart eventId={eventId} token={token} />

            <div className="mt-6">
                <GeographicChart eventId={eventId} token={token} />
            </div>
            <div className='mt-6'>
                <EngagementChartForFeedBack eventId={eventId} token={token} />
            </div>
        </div>
    );
};

export default ChartWrapper;

